<template>
    <main :class="['flex relative h-full min-w-0 flex-1 transition-all duration-200', 'bg-gray-200']">
        <div class="relative h-full w-full p-6 small_desktop:p-8 overflow-y-auto">
            <slot></slot>
        </div>
    </main>
</template>

<script>
export default {
    name: 'YpMain',

    computed: {
        navbarCollapse() {
            return this.$store.getters['auth/user'] ? this.$store.getters['navbar/navbarCollapse'] : false;
        },

        hasEmailConfirmation() {
            return this.$store.getters['auth/hasEmailConfirmation'];
        },
    },
};
</script>
